import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useTitle } from './TitleContext'; // Import the provider
import FTarticle from '../images/FT Article.png';
import DemoTweet from '../images/HHJ Tweet.png';
import DemoTweet2 from '../images/Akber Tweet.png';
import Forbesarticle from '../images/Forbes Article.png';
import './PoliticalBias.css';

function PoliticalBias() {
  const navigate = useNavigate()
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle("Political Bias Tracker"); // Set the title for the home page
  }, [setTitle]);
  const goHome = () => {
    navigate('/');  // Navigate to the home page
    window.scrollTo(0, 0);  // Scroll to the top of the page
  };
  return (
    <div className="main-content">
        <div className="tracker-container">
          <img src={FTarticle} alt="Financial Times article"/>
          <div className="pol-tracker-info-wrapper">
            <div className="pol-tracker-info">
              <p><span className="highlight">Source:</span> Financial Times</p>
              <p><span className="highlight">Category:</span> News</p>
              <p><span className="highlight">Date:</span> 2/9/24 </p>
              <p><span className="highlight">Score:</span> -8 </p>
              <a href="https://www.ft.com/content/d3995b6e-3b63-4f7b-958e-17f990975b20" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-container">
          <img src={DemoTweet} alt="HHJ Tweet"/>
          <div className="pol-tracker-info-wrapper">
            <div className="pol-tracker-info">
              <p><span className="highlight">Source:</span> X (Twitter)</p>
              <p><span className="highlight">Category:</span> Social Media</p>
              <p><span className="highlight">Date:</span> 2/12/24 </p>
              <p><span className="highlight">Score:</span> -13 </p>
              <p><span className="highlight">Views:</span> 132,500 </p>
              <a href="https://twitter.com/HHJCentral/status/1757346669614510274" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-container">
          <img src={DemoTweet2} alt="Akber Tweet"/>
          <div className="pol-tracker-info-wrapper">
            <div className="pol-tracker-info">
              <p><span className="highlight">Source:</span> X (Twitter)</p>
              <p><span className="highlight">Category:</span> Social Media</p>
              <p><span className="highlight">Date:</span> 2/13/24 </p>
              <p><span className="highlight">Score:</span> -13 </p>
              <p><span className="highlight">Views:</span> 38,600 </p>
              <a href="https://twitter.com/akbereo/status/1757232386591408449" target="_blank">Link</a>
            </div>
          </div>
        </div>
        
        <div className="tracker-container">
          <img src={Forbesarticle} alt="Forbes article"/>
          <div className="pol-tracker-info-wrapper">
            <div className="pol-tracker-info">
              <p><span className="highlight">Source:</span> Forbes </p>
              <p><span className="highlight">Category:</span> News</p>
              <p><span className="highlight">Date:</span> 2/5/24 </p>
              <p><span className="highlight">Score:</span> -11 </p>
              <a href="https://www.forbes.com/sites/maryroeloffs/2024/02/05/mcdonalds-a-target-of-boycotts-like-starbucks-sees-stock-drop-earnings-hit-over-israel-hamas-war/?sh=2cb5ea9018ba" target="_blank">Link</a>
            </div>
          </div>
        </div>
        <div className="tracker-info">
          <button onClick={goHome}>Return</button>
        </div>
    </div>
  );
}

export default PoliticalBias;